import { useState } from "react";

const trailers = [
  {
    id: 1,
    title: "Bigg Boss Tamil",
    year: "2026",
    age: "U/A 16+",
    lang: "Tamil",
    desc:
      "The ultimate reality test begins! Makkal Selvan Vijay Sethupathi returns with a brand-new season...",
    src: "https://www.youtube.com/embed/2wtddXiROWA"
  },
  {
    id: 2,
    title: "Leo Return",
    year: "2024",
    age: "U/A 13+",
    lang: "Hindi",
    desc: "A man forced back into his violent past...",
    src: "https://www.youtube.com/embed/wT4HcYAeV5U"
  },
  {
    id: 3,
    title: "Dhoom 3",
    year: "2019",
    age: "U/A 13+",
    lang: "Hindi",
    desc: "Twin brothers seek revenge...",
    src: "https://www.youtube.com/embed/aF08WVSvCok"
  },
  {
    id: 4,
    title: "BABBAR SHER - Hindi Trailer",
    year: " 2025",
    age: "U/A 13+",
    lang: "Hindi",
    desc: "Salman Khan leads as Sher Ali Khan, an ex-military officer-turned-vigilante known for his unshakeable moral code and unwavering loyalty",
    src: "https://www.youtube.com/embed/1aEFHnID-AE"
  },
  {
    id: 5,
    title: "LAALACH",
    year: " 2026",
    age: "U/A 13+",
    lang: "Hindi",
    desc: "Queen of Bollywood meets King of Action in this high-octane thriller where ambition knows no bounds.",
    src: "https://www.youtube.com/embed/bnWgLyR6ZdE"
  }

];

const getThumb = (url) => {
  const id = url.split("/embed/")[1];
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
};

export default function HeroBanner() {
  const [active, setActive] = useState(trailers[0]);
  const [play, setPlay] = useState(false);

  return (
    <>
      {/* FULL PLAYER */}
      {play && (
        <div className="player-wrap">
          <div className="netflix-back" onClick={() => setPlay(false)}>
            ❮ Back
          </div>

          <iframe
            src={active.src + "?autoplay=1&mute=0"}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}

      {!play && (
        <div className="hero-full">
          <iframe
            src={active.src + "?autoplay=1&mute=0&controls=0"}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />

          <div className="hero-overlay"></div>

          {/* INFO CARD */}
          <div className="info-card">
            <h1>{active.title}</h1>

            <p className="meta">
              {active.year} • {active.age} • {active.lang}
            </p>

            <p className="desc">
              {active.desc}
            </p>

            <div className="btn-row">
              <button
                className="watch-btn"
                onClick={() => setPlay(true)}
              >
                ▶ Play
              </button>
            </div>
          </div>

          <div className="hero-slider">
            {trailers.map((t) => (
              <img
                key={t.id}
                src={getThumb(t.src)}
                className={active.id === t.id ? "active" : ""}
                onClick={() => setActive(t)}
              />
            ))}
          </div>
        </div>
      )}

      <style>{`
        .hero-full {
          height: 520px;
          width: 100%;
          position: relative;
          background: #000;
        }

        iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to right,#000 30%,transparent 70%);
        }

        /* INFO CARD */
        .info-card {
          position: absolute;
          left: 50px;
          bottom: 90px;
          width: 380px;
          background: rgb(45 117 90 / 24%);
          padding: 22px;
          border-radius: 12px;
          color: #d8ba5be8;
          box-shadow: 0 8px 30px rgba(0,0,0,0.6);
        }

        .info-card h1 {
          font-size: 26px;
          margin-bottom: 6px;
        }

        .meta {
          font-size: 13px;
          color: #bbb;
          margin-bottom: 8px;
        }

        .desc {
          font-size: 14px;
          line-height: 1.5;
          color: #ddd;
          max-height: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* BUTTONS */
        .btn-row {
          display: flex;
          gap: 12px;
          margin-top: 14px;
        }

        .watch-btn {
          background: #fff;
          color: #758b19f0;
          border: none;
          padding: 8px 22px;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .info-btn {
          background: rgba(255,255,255,0.2);
          color: #fff;
          border: none;
          padding: 8px 18px;
          border-radius: 6px;
          cursor: pointer;
          transition: 0.3s;
        }

        .watch-btn:hover,
        .info-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.6);
        }

        /* SLIDER */
        .hero-slider {
          position: absolute;
          right: 40px;
          bottom: 30px;
          display: flex;
          gap: 12px;
        }

        .hero-slider img {
          width: 110px;
          height: 65px;
          object-fit: cover;
          border-radius: 6px;
          opacity: 0.6;
          cursor: pointer;
          transition: 0.3s;
        }

        .hero-slider img:hover {
          opacity: 1;
          transform: scale(1.05);
        }

        .hero-slider img.active {
          border: 2px solid red;
          opacity: 1;
        }

        /* FULL PLAYER */
        .player-wrap {
          position: fixed;
          inset: 0;
          background: #000;
          z-index: 9999;
        }

        .player-wrap iframe {
          width: 100%;
          height: 100%;
        }

        /* NETFLIX BACK */
        .netflix-back {
          position: absolute;
          top: 22px;
          left: 22px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          z-index: 100;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: 0.3s;
        }

        .netflix-back:hover {
          transform: translateX(-4px);
          opacity: 0.8;
        }
      `}</style>
    </>
  );
}
